<script>
	import {createEventDispatcher} from 'svelte';
	
	export let alertModal = {
		on: false,
		message: ''
	};

	const dispatch = createEventDispatcher();
</script>

<div class="game-modal-wrap" class:on={alertModal.on} data-modal="alert">
	<div class="modal create">
		<div class="game-list">
			<div class="group">
				<p class="msg">{@html alertModal.message}</p>
			</div>
		</div>
		<div class="btn-wrap">
			<div class="group">
				<button type="button" class="btn" on:click={() => alertModal.on = false}>확인</button>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import '../../../public/resource/scss/mixin';
	.msg {
		text-align: center;
		width: 100%;
		font-size: 2rem;
		
		@include mobileMax(1280px) {
			font-size: 1.2rem;
		}
	}
	.game-modal-wrap {
		.btn-wrap {
			.group {
				.btn {
					width: 100%;
				}
			}
		}
	}
</style>